export const NavsAR = {
    items: [
        {
            name: "قائمة الاعمال",
            children: [
                {
                    name: "قائمة اعمالي",
                    url: "/ToDo/myToDo"
                },
                // {
                //     name: "قائمة اعمال الطلاب",
                //     url: "/ToDo/all-students"
                // },
                {
                    name: "قائمة اعمال المساعدين",
                    url: "/ToDo/all-assistants"
                }
            ]
        },
        {
            name: "الطلاب",
            url: "/AllStudents"
        },
        {
            name: "المساعدين",
            url: "/Assistans"
        },

        {
            name: "الاعدادات",
            url: "/Settings"
        },
        {
            name: "المنشورات",
            url: "/AllPosts"
        },
        {
            name: "إعدادات المراحل",
            url: "/Levels-settings"
        },
        {
            name: "عن التطبيق",
            url: "/about-us"
        },
        {
            name: "اتصل بنا",
            url: "/contact-us"
        },
        {
            name: "تسجيل الحضور",
            url: "/attendance"
        },
        {
            name: "لوحة التحكم",
            url: "/Dashboard"
        },
    ]
}

export const NavsEN = {
    items: [
        {
            name: "ToDo List",
            children: [
                {
                    name: "My ToDo List",
                    url: "/ToDo/myToDo"
                },
                // {
                //     name: "ToDo List of Students",
                //     url: "/ToDo/all-students"
                // },
                {
                    name: "ToDo List of Assistants",
                    url: "/ToDo/all-assistants"
                }
            ]
        },
        {
            name: "Students",
            url: "/AllStudents"
        },
        {
            name: "Assistants",
            url: "/Assistans"
        },

        {
            name: "Settings",
            url: "/Settings"
        },
        {
            name: "Posts",
            url: "/AllPosts"
        },
        // {
        //     name: "Add Level",
        //     url:"/Add-Level"
        // },
        {
            name: "Levels Settings",
            url: "/Levels-settings"
        },
        {
            name: "About Us",
            url: "/about-us"
        },
        {
            name: "Contact Us",
            url: "/contact-us"
        },
        {
            name: "Attendance",
            url: "/attendance"
        },
        {
            name: "Control Board",
            url: "/Dashboard"
        },
    ]
}
